import i18n from 'i18next';

export default function useTranslate() {
  // This is really simple for now but later we may need to load
  // translations as we go. This hook allow us to later hook with
  // a context provider for this need
  return (key, opts) => i18n.t(key, opts);
}
